import React from 'react';

class Footer extends React.Component{

  constructor(props) {
    super();
  }

  render() {
    let hide = this.props.hide ? 'hidden' : '';

    let year = new Date().getFullYear();

    return(
      <footer className={ hide }>
    		<div className="footDek">
    			<h1>✌☺</h1>
    			<hr/>
    			<ul className="footnote-links">
            <li><a href="https://customercenter.wsj.com/public/view/contactinformation.html" rel="nofollow">Customer Service</a></li>
            <li><a href="http://www.wsj.com/policy/subscriber-agreement" rel="nofollow">Subscriber Agreement</a></li>
            <li><a href="http://www.wsj.com/policy/privacy-policy" rel="nofollow">Privacy Policy</a></li>
            <li><a href="http://www.wsj.com/policy/cookie-policy" rel="nofollow">Cookie Policy</a></li>
            <li className="copyright">© { year } <a href="http://www.dowjones.com">Dow Jones &amp; Company</a>, Inc. All Rights Reserved.</li>
          </ul>
    		</div>
    		<figure style={{backgroundImage: "url('landing-page-images/cat.gif')"}}>
    		</figure>
    	</footer>
    )
  }
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js